export default "__VITE_ASSET__BE$0CndL__"